import "./BiobuzzScoringElementRenderer.css"
import {BiobuzzScoringElement} from "../../javaTypes";

// Use this excessively long name to avoid conflict with `BiobuzzScoringElement` enum
export default function BiobuzzScoringElementRenderer({value}: { value: BiobuzzScoringElement }) {
    let text = '';
    let className = '';
    switch (value) {
        case BiobuzzScoringElement.RED_NECTAR:
            text = 'R';
            className = 'red';
            break;
        case BiobuzzScoringElement.BLUE_NECTAR:
            text = 'B';
            className = 'blue';
            break;
        case BiobuzzScoringElement.POLLEN:
            text = 'P';
            className = 'pollen'
            break;
    }

    return <span className={`biobuzzScoringElement ${className}`}>{text}</span>
}